import { DSNotification } from 'components/DSNotification';
import { useAreenaService } from 'contexts/AreenaServiceContext';
import React from 'react';
import styles from './ExternalChannelsNotice.module.scss';
import { useTranslation } from 'hooks/useTranslation';

export const ExternalChannelsNotice: React.FC = () => {
  const { areenaService: service } = useAreenaService();
  const t = useTranslation();

  const showNotice = service === 'tv';

  return (
    showNotice && (
      <div className={styles.root}>
        <DSNotification
          type="info"
          state="primary"
          title={t('externalChannelsMissingNoticeTitle')}
          subtitle={t('externalChannelsMissingNoticeDescription')}
        />
      </div>
    )
  );
};
